import { render, staticRenderFns } from "./PowerupSearchEditComponent.vue?vue&type=template&id=cd828206&scoped=true"
import script from "./PowerupSearchEditComponent.vue?vue&type=script&lang=js"
export * from "./PowerupSearchEditComponent.vue?vue&type=script&lang=js"
import style0 from "./PowerupSearchEditComponent.vue?vue&type=style&index=0&id=cd828206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd828206",
  null
  
)

export default component.exports